<success-screen bgImage="coinsFiat" class="bp-modal mod-lg">
	<bp-modal-header header [title]="'deposit' | translate">
		<a (click)="close()" right href="javascript:;" (keydown.enter)="close()" [tabIndex]="0">
			{{ "close" | translate }}
		</a>
	</bp-modal-header>
	<div content class="success-content-inner">
		<div class="mb-90 text-center">
			<p class="font-size-17 text-light mb-0">{{ "could-not-deposit" | translate }}</p>
		</div>
		<div class="success-symbol mod-red mb-20">
			<span class="bpi__icon-send"></span>
		</div>
		<div class="success-headline mb-15">{{ "oops-something-wrong" | translate }}</div>
		<!--<p class="text-light text-center mb-15">
            {{ 'some-additional-text-for-deposit-failed' | translate }}
        </p>-->
		<div class="mb-50 text-center">
			<a (click)="tryAgain()" href="javascript:;">{{ "try_again" | translate }}</a>
		</div>
		<div class="mb-50 text-center">
			<a (click)="goToSavings()">{{ "recurring_buy_success_screen_goto" | translate }}</a>
		</div>
		<div class="text-center mb-20">
			<button class="btn btn-primary btn-wide" type="button" (click)="close()">
				{{ "i-will-do-it-later" | translate }}
			</button>
		</div>
		<div class="text-center">
			<a (click)="close()" href="javascript:;">{{ "cancel-transaction" | translate }}</a>
		</div>
	</div>
</success-screen>
